'use client'

import { Container } from '@/shared/components/Container'
import { motion } from 'framer-motion'
import SlowRevealSpan from '@/shared/components/interactive/SlowRevealSpan'
import Counter from '@/shared/components/framer/Counter'
import React, { Fragment } from 'react'

export default function ClinicStatisticsHeaderVic() {
  return (
    <div className="mt-40">
      <Container>
        <div className="flex flex-col items-center">
          <div className="overflow-hidden">
            <motion.h1
              className="font-bitter text-2xl text-gray-800 md:text-3xl xl:text-4xl"
              initial={{ y: 100 }}
              animate={{ y: 0 }}
              transition={{
                duration: 0.5,
                ease: 'easeOut',
              }}
            >
              Looking for a doctor in Victoria?
            </motion.h1>
          </div>
          <div className="mt-3 max-w-3xl font-sans text-lg font-light leading-relaxed text-gray-700 md:text-xl xl:mt-6 xl:text-2xl">
            <motion.p
              variants={{
                start: { opacity: 0 },
                end: { opacity: 1, transition: { staggerChildren: 0.05 } },
              }}
              transition={{
                delay: 0.3,
                ease: 'easeOut',
              }}
              initial="start"
              animate="end"
            >
              {'Did you know that in all of Victoria, approximately, there are only'
                .split(' ')
                .map((text, idx) => (
                  <Fragment key={`0-${idx}`}>
                    <SlowRevealSpan>{text}</SlowRevealSpan>{' '}
                  </Fragment>
                ))}
              <Counter value={356} className="font-medium text-rose-500" />{' '}
              {'clinics serving almost'.split(' ').map((text, idx) => (
                <Fragment key={`1-${idx}`}>
                  <SlowRevealSpan>{text}</SlowRevealSpan>{' '}
                </Fragment>
              ))}
              <SlowRevealSpan className="font-medium text-orange-500">
                <Counter value={7} className="font-medium text-orange-500" />{' '}
                million
              </SlowRevealSpan>{' '}
              {'people? That means each clinic is serving'
                .split(' ')
                .map((text, idx) => (
                  <Fragment key={`2-${idx}`}>
                    <SlowRevealSpan>{text}</SlowRevealSpan>{' '}
                  </Fragment>
                ))}
              <SlowRevealSpan>
                <Counter value={20000} className="font-medium text-green-500" />
              </SlowRevealSpan>{' '}
              {'people - roughly the entire population of'
                .split(' ')
                .map((text, idx) => (
                  <Fragment key={`3-${idx}`}>
                    <SlowRevealSpan>{text}</SlowRevealSpan>{' '}
                  </Fragment>
                ))}
              <span className="relative inline-flex overflow-hidden font-bold">
                <motion.span
                  className="absolute bottom-1 left-0 block h-1.5 w-full bg-blue-400 xl:bottom-1.5 xl:h-2"
                  initial={{ width: 0 }}
                  animate={{ width: '100%' }}
                  transition={{ ease: 'easeOut', duration: 0.3, delay: 0.8 }}
                ></motion.span>
                <motion.span
                  className="relative inline-block"
                  initial={{ y: 100 }}
                  animate={{ y: 0 }}
                  transition={{ ease: 'easeOut', duration: 0.4, delay: 0.4 }}
                >
                  Warragul
                </motion.span>
              </span>
            </motion.p>
          </div>
        </div>
      </Container>
    </div>
  )
}
